import { UseFormMethods } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { ColorScheme, Flex } from '@hivewatch/dark'

import { ControlledSelect } from '@/components/ui'

import { Options } from '../../types/types'
import { FormInputsIProps } from '../types/types'
import { deviceTypes } from '../utils/utils'
import { DarkGenericDeviceForm } from './DarkGenericDeviceForm'

interface DarkCreateDeviceFormIProps {
  form: UseFormMethods<FormInputsIProps>
  facilityOptions: Options
  floorOptions: Options
  isOptionsLoading: boolean
  isFacilitiesLoading: boolean
  isFacilitiesError: boolean
  isIncidentTypesLoading: boolean
  incidentTypeOptions: Options
  setFacilityName: React.Dispatch<React.SetStateAction<string>>
  colorScheme: ColorScheme
}

/** Rebrand variant of {@link CreateDeviceForm}. */
export const DarkCreateDeviceForm = ({
  form,
  isFacilitiesLoading,
  isFacilitiesError,
  isOptionsLoading,
  facilityOptions,
  floorOptions,
  isIncidentTypesLoading,
  incidentTypeOptions,
  setFacilityName,
  colorScheme,
}: DarkCreateDeviceFormIProps) => {
  const { t } = useTranslation()
  const { control, errors } = form

  return (
    <Flex direction='column' gap='16px'>
      <ControlledSelect
        colorScheme={colorScheme}
        control={control}
        hasWarning={!!errors?.type}
        isClearable
        label={t('devices:crud_type_label')}
        name='type'
        options={deviceTypes}
        placeholder={t('devices:crud_type_selection')}
        rules={{ required: true }}
        warningText={t('devices:crud_type_required')}
      />

      <DarkGenericDeviceForm
        colorScheme={colorScheme}
        facilityOptions={facilityOptions}
        floorOptions={floorOptions}
        form={form}
        incidentTypeOptions={incidentTypeOptions}
        isFacilitiesError={isFacilitiesError}
        isFacilitiesLoading={isFacilitiesLoading}
        isIncidentTypesLoading={isIncidentTypesLoading}
        isOptionsLoading={isOptionsLoading}
        setFacilityName={setFacilityName}
      />
    </Flex>
  )
}
